import React from 'react';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import ValidationError from '../ValidationError/ValidationError';
import css from './FieldToggleGroup.module.css';

const FieldToggleGroup = props => {
    const {
        className,
        id,
        name,
        label,
        options,
        validate,
    } = props;

    return <Field id={id} name={name} validate={validate}>
        {({ input, meta }) => {
            const valueArray = Array.isArray(input.value) ? input.value : [];

            const handleToggleClick = (value) => {
                const newValue = valueArray.includes(value)
                    ? valueArray.filter((v) => v !== value)
                    : [...valueArray, value];

                input.onChange(newValue);
            };

            return <div className={classNames(css.toggleInputGroup, className)}>
                {label ? <legend>{label}</legend> : null}
                <div className={css.options}>
                    {options.map((option) => (
                        <button
                            key={option.key}
                            type="button"
                            className={`${css.toggleBtn} ${valueArray.includes(option.key) ? css.active : ''}`}
                            onClick={() => handleToggleClick(option.key)}
                            onBlur={input.onBlur}
                            onFocus={input.onFocus}
                        >
                            {option.label}
                        </button>
                    ))}
                </div>

                <ValidationError fieldMeta={meta} useDirty={true} />
            </div>
        }}
    </Field>
};

export default FieldToggleGroup;
